import { EmitsToProps, Reactive } from "@vue/runtime-core";
import { ContextMenu } from "@/components/context-menu/mag-context-menu";
import { Component, markRaw, nextTick, reactive } from "vue";
import { ComponentPropsMaybeRef, Emits } from "@/component-types";
import { v7 } from "uuid";

export type PopoverLayerItem =
    | {
          kind: "mag-dialog";
          id: string;
          component: Component;
      }
    | {
          kind: "legacy-dialog";
          id: string;
          component: any;
          props: Record<string, any>;
          events: EmitsToProps<any>;
      }
    | ContextMenu;

export class PopoverLayer {
    id: number;
    items: Reactive<PopoverLayerItem[]>;
    closing: boolean;

    constructor(id: number) {
        this.id = id;
        this.items = reactive([]);
        this.closing = false;
    }
}

export const popoverLayers = [] as PopoverLayer[];

export function placePopover(item: PopoverLayerItem) {
    const placement = popoverLayers.findLastIndex((l) => !l.closing);
    popoverLayers.at(placement)!.items.push(item);
}

export function removePopover(id: string) {
    for (let i = popoverLayers.length - 1; i >= 0; i--) {
        const layer = popoverLayers[i];

        const idx = layer.items.findIndex((p) => p.id === id);

        if (idx === -1) {
            continue;
        }

        layer.items.splice(idx, 1);
        return;
    }
}

export async function spawnPopover<C extends Component>(
    component: C,
    props: ComponentPropsMaybeRef<NoInfer<C>>,
    disposeEvent?: keyof Emits<NoInfer<C>>,
    closePromise?: Promise<void>,
) {
    const id = v7();

    const { resolve, promise } = Promise.withResolvers<void>();

    if (closePromise) {
        closePromise.then(resolve);
    }

    placePopover({
        kind: "legacy-dialog",
        id,
        component: markRaw(component),
        props,
        events: disposeEvent
            ? {
                  [disposeEvent]: () => resolve(),
              }
            : {},
    });

    await promise.finally(async () => {
        await nextTick();
        removePopover(id);
    });
}
